const Select = (($) => {

    const NAME = 'select';
    const DATA_KEY = `bs.${NAME}`;
    const JQUERY_NO_CONFLICT = $.fn[NAME];

    const Default = {
        container: false,//'body',
        noneSelectedText: '...',
        
        actionsBox: false,
        countSelectedText(numSelected, numTotal) {
            return (numSelected === 1) ? "{0} item selected" : "{0} items selected";
        },
        deselectAllText: 'Deselect All',
        dropdownAlignRight: false,
        header: false,
        liveSearch: false,
        liveSearchPlaceholder: null,
        liveSearchStyle: 'contains',
        maxOptions: false,
        menuClass: null,
        selectedAllText: 'Select All',
        selectedTextFormat: 'values',
        showContent: true,
        showIcon: true,
        showSubtext: false,
        size: 'auto',
        style: 'btn-default',
        title: null,
        width: '100%'
    };
    const Selector = {
        SELECT: `.js-${NAME}`
    }

    class Select {
        constructor(element, config) {
            this._config = config;
            this._element = element;
            this.$element = $(element);

            this.$element.on('change', function () {
                const $select = $(this);

                if (!$select.closest('.dropdown-content').length) {
                    //$select.trigger('click'); // trigger reevaluation
                }
            });
            if (this._config.menuClass) {
                this.$element.on('show.bs.dropdown', function() {
                    $(this).find('.dropdown-menu').addClass(this._config.menuClass);
                });
            }
        }

        dispose() {
            $.removeData(this._element, DATA_KEY);
            this._config = null;
            this._element = null;
        }

        static _jQueryInterface() {
            return this.each(function () {
                const $this = $(this);
                let data = $this.data(DATA_KEY);
                const config = $.extend({}, Default, $this.data());
                if (!data) {
                    data = new Select(this, config);
                    $this.data(DATA_KEY, data).selectpicker(config);
                }
            });
        }
    }

    $.fn.selectpicker.defaults = {
        iconBase: '',
        tickIcon: 'fa fa-check'
    };
    $(() => Select._jQueryInterface.call($(Selector.SELECT)));
    $(document).ajaxStop(() => Select._jQueryInterface.call($(Selector.SELECT)));

    $.fn[NAME] = Select._jQueryInterface;
    $.fn[NAME].Constructor = Select;
    $.fn[NAME].noConflict = function () {
        $.fn[NAME] = JQUERY_NO_CONFLICT;
        return Select._jQueryInterface;
    }

    return Select;
})(jQuery);